import { UrlApi } from "../../../services/apirest";
import { buildQueryParams } from "../../../utils/buildQueryParams";

export const getSemaforoExcel = async (filters) => {
  const params = buildQueryParams(filters);

  const response = await fetch(`${UrlApi}/semaforo/excel?${params.toString()}`);

  if (!response.ok) {
    throw new Error("Error al generar el Excel");
  }

  return response.blob();
};
